// extracted by mini-css-extract-plugin
module.exports =  {"alert":"UjgtyYnLJ0dJ5PyAnezv"};